const closeButtonLabel = "Cerrar";
const esPE = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  esPE as default
};
